import axios from 'axios';
import { LcBearerKey } from '../global';
import { LocalStorageHelper } from './localstorage.helper';
export const multipartFormDataConfig = {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
};
export class Http {
    static withUrl(url) {
        this.instance.defaults.baseURL = url;
        return this.instance;
    }
}
Http.instance = axios.create({});
export class HttpAuth {
    static sync() {
        const bearer = LocalStorageHelper.getItem(LcBearerKey);
        if (bearer) {
            this.withBearer(bearer);
        }
    }
    static withBearer(bearer) {
        this.withHeader('Authorization', `Bearer ${bearer}`);
        return this.instance;
    }
    static withHeader(headerKey, headerValue) {
        this.instance.defaults.headers[headerKey] = headerValue;
        return this;
    }
    static withUrl(url) {
        this.instance.defaults.baseURL = url;
        return this.instance;
    }
}
HttpAuth.instance = axios.create({});
